<template>
	<div class="width-100 flex-justify-space-between display-flex flex-row flex-align-center">
		<div class="display-flex flex-row flex-align-center">
			<div
				:key="tab.id"
				class="tab-button"
				@click="() => (localValue = disabledTabs.includes(i) ? localValue : i)"
				v-for="(tab, i) in featureTypesBySections"
				:class="{ selected: i === localValue, disabled: disabledTabs.includes(i) }"
			>
				<div class="tab-title">{{ tab.title }}</div>
				<div class="tab-description">{{ tab.description }}</div>
			</div>
		</div>
		<a class="link" href="https://videos.ply.io/watch/MTY2OTE1NA==" target="_blank">
			Learn
			<SIcon class="ml-1 svg" :name="'play-video'" />
		</a>
	</div>
</template>

<script>
import VModelMixin from '@/mixins/VModelMixin';
export default {
	name: 'FeatureTypeSelectorTabs',
	mixins: [VModelMixin],
	components: {},
	props: { featureTypesBySections: { type: Array }, disabledTabs: { type: Array } },
};
</script>

<style lang="scss" scoped>
.tab-title {
	font-size: 16px;
	font-weight: medium;
	letter-spacing: 0px;
	color: var(--primary-font-color);
}
.tab-description {
	font-size: 12px;
	color: #6c7689;
	font-weight: medium;
	letter-spacing: 0px;
}
.tab-button {
	margin-right: 64px;
	padding-right: 12px;
	cursor: pointer;
	opacity: 0.8;
	transition: 0.3s;

	&.selected {
		opacity: 1;
		border-bottom: 2px solid #282828;
		transition: 0.2s;
	}
	&.disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
}
.link {
	text-decoration: none;
	color: #b5bac4;
	font-size: 12px;
	::v-deep(svg) {
		rect {
			stroke: #b5bac4;
		}
		path {
			fill: #b5bac4;
		}
	}
}
</style>
